import { render, staticRenderFns } from "./DataTableScanProducts.vue?vue&type=template&id=24674d02&scoped=true&"
import script from "./DataTableScanProducts.vue?vue&type=script&lang=ts&"
export * from "./DataTableScanProducts.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableScanProducts.vue?vue&type=style&index=0&id=24674d02&scoped=true&lang=scss&"
import style1 from "./DataTableScanProducts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24674d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VCol,VDataTable,VDialog,VIcon,VProgressCircular,VRow,VSimpleTable,VSpacer,VToolbar,VToolbarTitle})
